// import { color2rgba } from "./color";

import { color2rgba } from "./color";
export function bindingSVG(svg, palette) {
  return svg === null || svg === void 0 ? void 0 : svg.replace(/var\(--palette-(.*?)(\s*,\s*(.*?))?\)/g, function (_, $1, _2, $declaration) {
    return palette.hasOwnProperty($1) ? color2rgba(Reflect.get(palette, $1)) : $declaration;
  });
  // const document = parser.parseFromString(content, "image/svg+xml");
  // const svgElement = document.querySelector('svg');
  // if (options) {
  //   svgElement.setAttribute("width", String(options.width));
  //   svgElement.setAttribute("height", String(options.height));
  // }
  // return serializer.serializeToString(svgElement);
}